if (typeof $ === 'undefined') {
  var $ = jQuery;
}

class TabGroup {
  constructor(el, args) {
    this.defaults = {
      select: '.tabs__select select',
      links: '.tabs__link',
      panels: '.tabs__panel',
    };
    this.options = Object.assign({}, this.defaults, args);
    this.container = el;
    this.$container = $(el);
    this.groupId = 'group-' + this.options.groupId;
    this.selects = this.getSelects(this.options.select);
    this.links = this.getLinks(this.options.links);
    this.panels = this.getPanels(this.options.panels);
    this.listen();
  }
  listen() {
    var instance = this;
    this.$container.on('TabsCollection:sync', function (e, id) {
      instance.sync(id);
    });

    $(document).ready(function () {
      var urlParam = '#' + getUrlVars()[instance.groupId];
      var urlTab = instance.links.find((t) => t.id === urlParam);
      var id = urlTab ? urlTab.id : instance.links[0].id;
      instance.$container.addClass('tabs--initialized');
      instance.sync(id);
    });
  }
  getSelects(selector) {
    var selects = [];
    this.$container.find(selector).each(function (i, el) {
      var select = new TabSelect(el);
      selects.push(select);
    });
    return selects;
  }
  getLinks(selector) {
    var links = [];
    this.$container.find(selector).each(function (i, el) {
      var link = new TabTrigger(el);
      links.push(link);
    });
    return links;
  }
  getPanels(selector) {
    var panels = [];
    this.$container.find(selector).each(function (i, el) {
      var panel = new TabPanel(el);
      panels.push(panel);
    });
    return panels;
  }
  sync(id) {
    var trigger = this.links.find((t) => t.id === id);
    var panel = this.panels.find((p) => p.id === id);
    if (!trigger.active && !panel.active) {
      this.deactivate();
      this.activate(id);
    }
  }
  activate(id) {
    var select = this.selects[0];
    var trigger = this.links.find((t) => t.id === id);
    var panel = this.panels.find((p) => p.id === id);
    select.setID(id);
    trigger.activate();
    panel.activate();
  }
  deactivate() {
    var trigger = this.links.find((t) => t.active);
    var panel = this.panels.find((p) => p.active);
    if (trigger) {
      trigger.deactivate();
    }
    if (panel) {
      panel.deactivate();
    }
  }
}
class TabSelect {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.id;
    this.getID();
    this.listen();
  }
  listen() {
    var instance = this;
    this.$el.on('change', function (e) {
      e.preventDefault();
      $(this).trigger('TabSelect:change', [instance]);
      $(this).trigger('TabsCollection:sync', [instance.getID()]);
    });
  }
  getID() {
    this.id = this.$el.val();
    return this.id;
  }
  setID(id) {
    this.id = id;
    this.$el.val(id);
    this.setLabel();
  }
  setLabel() {
    this.$el.siblings('ins').text(this.$el.find('option:selected').text());
  }
}
class TabTrigger {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.active = false;
    this.id = this.$el.attr('href');
    this.listen();
  }
  listen() {
    this.$el.on('click', (e) => {
      e.preventDefault();
      $(e.target).trigger('TabTrigger:click', [this]);
      $(e.target).trigger('TabsCollection:sync', [this.id]);
    });
  }
  activate() {
    this.active = true;
    $(this).trigger('TabTrigger:activated', [this]);
    this.$el.addClass('active');
  }
  deactivate() {
    this.active = false;
    $(this).trigger('TabTrigger:deactivated', [this]);
    this.$el.removeClass('active');
  }
}
class TabPanel {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.active = false;
    this.id = '#' + this.$el.attr('id');
  }
  activate() {
    this.active = true;
    this.$el.trigger('TabPanel:activated', [this]);
    this.$el.velocity('fadeIn', {
      duration: 200,
      begin: function () {
        $(this).addClass('active');
      },
    });
  }
  deactivate() {
    this.$el.trigger('TabPanel:deactivated', [this]);
    this.active = false;
    this.$el.velocity('fadeOut', {
      duration: 0,
      begin: function () {
        $(this).removeClass('active');
      },
    });
  }
}


/*************************************************************************************
 * Call functions on Doc Ready
 *************************************************************************************/
$(document).ready(function () {
  $('body')
    .find('.tabs')
    .each((i, el) => {
      new TabGroup(el, {
        groupId: i + 1,
      });
    });
}); //Doc Ready
